import { combineReducers } from 'redux';

// Reducers
import app from './app';
import content from './content';
import locations from './locations';
import map from './map';
import search from './search';
import service from './service';

const reducers = combineReducers({
  app,
  content,
  locations,
  map,
  search,
  service,
});

export default reducers;
